import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/work-order'

export const show = async (params) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/detail`,
    params: params,
  })

  return response
}

export const showAdasDms = async (task_id, params) => {
  const response = await apiClient({
    method: 'GET',
    baseURL: `${process.env.VUE_APP_API_SMS_URL}/transjakarta/sop-alert-simulation/${task_id}`,
    params: params,
  })

  return response
}

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })

  return response
}

export const setToDraft = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/set-to-draft/${id}`,
    data,
  })

  return response
}

export const sendToErp = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/send-to-erp`,
    data,
  })

  return response
}

export const exportDetail = async (id, params) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/export-detail/${id}`,
    responseType: 'blob',
    params: params,
    headers: { 'Accept-Language': process.env.VUE_APP_I18N_LOCALE },
  })

  return response
}
